import React from "react";
import "../App.css";
import Footer from "../components/Footer";

function Services() {
    return (
        <>
            <h1 className="services">SERVICES</h1>
            <Footer />
        </>
    );
}

export default Services;
